<template>
  <div class="page-container">
    <el-breadcrumb separator="/">
      <el-breadcrumb-item>验证码历史记录</el-breadcrumb-item>
    </el-breadcrumb>
    <el-card class="page-content" shadow="never">
      <!-- <div class="page-actions">
        <el-button type="primary" @click="showInfo" size="mini"
          >查看详情</el-button
        >
      </div> -->
      <user-list @refresh="refreshList"></user-list>
    </el-card>
    <el-dialog
      title="详情"
      :visible.sync="dialogVisible"
      width="30%"
      :before-close="handleClose"
      :show-close="false"
    >
      <el-form ref="form" :model="form" :rules="rules" label-width="120px">
        <el-form-item label="谷歌验证码" prop="googleCode">
          <el-input v-model="form.googleCode"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="submit">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import "./store";
import UserList from "./components/list";
import { mapState, mapActions } from "vuex";
import { PAGINATION } from "./constants";
import api from "./api";
export default {
  name: "UserVerify",
  components: {
    UserList,
  },
  data() {
    return {
      dialogVisible: false,
      form: {},
      rules: {
        googleCode: [
          { required: true, message: "请填写谷歌验证码", trigger: blur },
        ],
      },
    };
  },
  computed: {
    ...mapState("userVerify", ["queryType", "queryTypeList", "pagination"]),
  },
  methods: {
    ...mapActions("userVerify", ["list"]),
    refreshList(data = {}) {
      this.list({
        ...this.pagination,
        ...data,
      });
    },
    showInfo() {
      this.dialogVisible = true;
      this.form = {};
    },
    submit() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          api
            .historyDetail({
              googleCode: this.form.googleCode,
            })
            .then((res) => {
              if (res.code == 0) {
                this.dialogVisible = false;
                this.form = {};
                this.$message({
                  message: "操作成功！",
                  type: "success",
                });
                this.$refs.form.resetFields();
                this.refreshList();
              }
            });
        }
      });
    },
    handleClose(done) {
      if (this.$refs.form) {
        this.$refs.form.resetFields();
      }
      done();
    },
  },
  mounted() {
    this.list({
      ...PAGINATION,
    });
  },
};
</script>

<style lang="less" scoped></style>
